import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/grade-and-section-report/GradeAndSectionReportAction";
import * as uiHelpers from "../GradeAndSectionReportUIHelpers";
import {
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useGradeAndSectionReportUIContext } from "../GradeAndSectionReportUIContext";
import { GroupButtonsTable } from "./GroupButtonsTable";

export function GradeAndSectionReportTable() {
  // Grade And Section Report UI Context
  const gradeAndSectionReportUIContext = useGradeAndSectionReportUIContext();
  const gradeAndSectionReportUIProps = useMemo(() => {
    return {
      data: gradeAndSectionReportUIContext.data,
      columns: gradeAndSectionReportUIContext.columns,
      queryParams: gradeAndSectionReportUIContext.queryParams,
      setQueryParams: gradeAndSectionReportUIContext.setQueryParams
    };
  }, [gradeAndSectionReportUIContext]);

  // Getting curret state of Grade And Section Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.gradeAndSectionReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Grade And Section Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getGradeAndSectionReport(gradeAndSectionReportUIProps.queryParams));
    return () => dispatch(actions.cleanGradeAndSectionReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradeAndSectionReportUIProps.queryParams, dispatch]);

  const rowClasses = row => typeof(row.id) === "number" ? "font-weight-bold" : "";

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: gradeAndSectionReportUIProps.queryParams.pageSize,
    page: gradeAndSectionReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <GroupButtonsTable />
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={gradeAndSectionReportUIProps.data}
              columns={gradeAndSectionReportUIProps.columns}
              rowClasses={rowClasses}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                gradeAndSectionReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}